import { Link } from "react-router-dom";
import { theme } from "../theme";

// ── Chybí shop_id ─────────────────────────────────────────────────────────────
// Bez nastaveného e-shopu scheduler nepozná, která nabídka na Heurece je
// uživatelova, takže se pozice nikdy nezapíše. Tenhle stav proto nestojí NAD
// daty jako banner, ale nahrazuje přesně ta místa, kde by data měla být —
// a mizí sám, jakmile se shop_id vyplní. Není co odklikávat.
export default function ShopSetupNotice({ title, children, compact = false, actionLabel = "Nastavit e-shop", onAction }) {
  const actionStyle = {
    background: theme.blue, color: "#fff", textDecoration: "none", border: "none",
    borderRadius: theme.rBtn, padding: "9px 18px",
    fontSize: 13.5, fontWeight: 700, whiteSpace: "nowrap", flexShrink: 0,
    cursor: "pointer", fontFamily: "inherit",
  };
  return (
    <div className="fadeUp" style={{
      background: theme.blueSoft, border: `1.5px solid ${theme.blueLine}`,
      borderRadius: theme.rCard, padding: compact ? "14px 18px" : "18px 22px",
      marginBottom: compact ? 0 : 20,
      display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: theme.rTile, flexShrink: 0,
        background: theme.bg, border: `1px solid ${theme.blueLine}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={theme.blue} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9h18M3 9l1.5-4.5A2 2 0 0 1 6.4 3h11.2a2 2 0 0 1 1.9 1.5L21 9M3 9v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9M9 13h6"/>
        </svg>
      </div>
      <div style={{ minWidth: 0, flex: 1 }}>
        <p style={{ fontWeight: 700, fontSize: 15, color: theme.ink, marginBottom: 3 }}>{title}</p>
        <p style={{ fontSize: 13, color: theme.inkSoft, lineHeight: 1.5 }}>{children}</p>
      </div>
      {onAction
        ? <button onClick={onAction} style={actionStyle}>{actionLabel}</button>
        : <Link to="/nastaveni" style={actionStyle}>{actionLabel}</Link>}
    </div>
  );
}
